document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.anniversary-8th-sitewide').forEach((section) => {
    const copyBtn = section.querySelector('[data-copy-trigger]');
    const codeEl = section.querySelector('[data-copy-code]');

    if (!copyBtn || !codeEl) return;

    const defaultLabel = copyBtn.textContent.trim();
    const successLabel = section.dataset.copySuccess || 'COPIED';

    copyBtn.addEventListener('click', async () => {
      const code = codeEl.textContent.trim();

      try {
        await navigator.clipboard.writeText(code);
        copyBtn.textContent = successLabel;
        copyBtn.classList.add('is-copied');
      } catch (error) {
        console.error('Copy failed:', error);
      }
    });
  });
});
